export default {
  "agentCashbackAdmin.title": "Agent Cashback Admin",
  "agentCashbackAdmin.thead.index": "#No",
  "agentCashbackAdmin.thead.id": "ID",
  "agentCashbackAdmin.thead.gameType": "GameType",
  "agentCashbackAdmin.thead.inviteUserNum": "InviteUserNum",
  "agentCashbackAdmin.thead.betAmount": "BetAmount",
  "agentCashbackAdmin.thead.bonus": "Bonus",
  "agentCashbackAdmin.thead.withdrawLimitRatio": "WithdrawLimitRatio",
  "agentCashbackAdmin.thead.createTime": "CreateTime",
  "agentCashbackAdmin.thead.modifyTime": "ModifyTime",
  "agentCashbackAdmin.thead.operator": "Operator",

  "agentCashbackAdmin.thead.action": "Action",
  "agentCashbackAdmin.add": "Add",
  "agentCashbackAdmin.edit": "Edit",
  "agentCashbackAdmin.details": "Details",
  "agentCashbackAdmin.delete": "Delete",
};
